import React, { Component } from 'react';
import Parse from 'parse';

export default class ParseEditableSelect extends Component {
  constructor(props) {
      super(props);
      this.state = ({
        value:this.props.parsevalue,
      })
  }

  onChange = (e) => {
    var parseclass = this.props.parseclass;
    var parseobjectid = this.props.parseobjectid;
    var parsekey = this.props.parsekey;
    var value = e.target.value;
    this.setState({
      value:value
    })
    var Query = Parse.Object.extend(parseclass);
    var query = new Parse.Query(Query);
    query.get(parseobjectid,{
      success: function (result) {
          result.set(parsekey,value)
          result.save(null, {
            success: function(result) {
            },
            error: function(result, error) {
              console.log(result)
            }
          });
      },
      error: function(error) {
          console.log("Error: " + error.code + " " + error.message);
      }
    })
  }

  render() {
    return (
      <div>
        <select value={this.state.value} onChange={this.onChange}>
          <option value={undefined}>{""}</option>
          {this.props.options.map((data)=>{
            return(
              <option value={data}>{data}</option>
            )
          })}
        </select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/parseEditableSelect.js